// Handle opening the modal
document
	.querySelectorAll('a[href^="#product-search-popup"]')
	.forEach((trigger) => {
		trigger.addEventListener("click", (e) => {
			e.preventDefault();
			const modal = document.querySelector("#product-search-popup");
			if (modal) {
				modal.classList.add("is-active");
				document.body.style.overflow = "hidden";
			}
		});
	});

// Function to close modal and remove hash
function closeModal() {
	const modal = document.querySelector("#product-search-popup");
	if (modal) {
		modal.classList.remove("is-active");
		document.body.style.overflow = "auto";

		// Remove hash from URL without page reload
		if (window.location.hash) {
			history.replaceState(null, null, " ");
		}
	}
}

// Handle close button (use event delegation for dynamic content)
document.addEventListener("click", (e) => {
	// Check if clicked element is the close button
	if (e.target.matches(".popup .close") || e.target.closest(".popup .close")) {
		e.preventDefault();
		closeModal();
	}
});

// Handle overlay click to close modal
const overlay = document.querySelector(".overlay");
if (overlay) {
	overlay.addEventListener("click", (e) => {
		// Only close if clicking on the overlay itself, not the popup content
		if (e.target === overlay) {
			closeModal();
		}
	});
}

// Handle ESC key to close modal
document.addEventListener("keydown", (e) => {
	if (e.key === "Escape") {
		const modal = document.querySelector("#product-search-popup");
		if (modal && modal.classList.contains("is-active")) {
			closeModal();
		}
	}
});

// Auto-close modal after successful form submission (optional)
jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
	if (formId === 6) { // Form ID 6
		// Optional: Auto-close after 3 seconds
		setTimeout(function() {
			closeModal();
		}, 3000);
	}
});
